export const enableScrolling = () => {
    document.body.style.overflow = "auto";
};
export default enableScrolling;
